const AppleWeedsList = ({ issues, toDisplay }) => {
    if (issues.length === 0) {
        return <></>;
    }
    const values = issues.filter(value => toDisplay.includes(value));
    if (values.length === 0) {
        return <></>;
    } return (
        <>
            <ul className="list-group list-group-horizontal list-group-flush">
                <li className="list-group-item">
                    Useful for:
                </li>
                {values.includes('windBlownWeeds'.toLowerCase()) ?
                    <li className="list-group-item list-group-item-primary">
                        <a href="https://horticulture.ahdb.org.uk/knowledge-library/pocket-weed-identification-guide" target="_blank" rel="noreferrer">Wind blown weeds</a>
                    </li>
                    : <></>
                }
                {values.includes('tapRootBlwApple'.toLowerCase()) ?
                    <li className="list-group-item list-group-item-primary">
                        <a href="https://ahdb.org.uk/knowledge-library/distribution-and-biology-of-creeping-thistle-in-the-uk" target="_blank" rel="noreferrer">Tap Root BLW</a>
                    </li>
                    : <></>
                }
                {values.includes('fibrousRootBlwApple'.toLowerCase()) ?
                    <li className="list-group-item list-group-item-primary">
                        <a href="https://ahdb.org.uk/knowledge-library/distribution-and-biology-of-creeping-thistle-in-the-uk" target="_blank" rel="noreferrer">Fibrous Root BLW</a>
                    </li>
                    : <></>
                }
                {values.includes('couch'.toLowerCase()) ?
                    <li className="list-group-item list-group-item-primary">
                        <a href="https://ahdb.org.uk/knowledge-library/distribution-and-biology-of-creeping-thistle-in-the-uk" target="_blank" rel="noreferrer">Couch</a>
                    </li>
                    : <></>
                }
                {values.includes('docks'.toLowerCase()) ?
                    <li className="list-group-item list-group-item-primary">
                        <a href="https://ahdb.org.uk/knowledge-library/distribution-and-biology-of-creeping-thistle-in-the-uk" target="_blank" rel="noreferrer">Docks</a>
                    </li>
                    : <></>
                }
                {values.includes('creepingThistle'.toLowerCase()) ?
                    <li className="list-group-item list-group-item-primary">
                        <a href="https://ahdb.org.uk/knowledge-library/distribution-and-biology-of-creeping-thistle-in-the-uk" target="_blank" rel="noreferrer">Creeping Thistle</a>
                    </li>
                    : <></>
                }
                {values.includes('spearThistle'.toLowerCase()) ?
                    <li className="list-group-item list-group-item-primary">
                        <a href="https://ahdb.org.uk/knowledge-library/distribution-and-biology-of-spear-thistle-in-the-uk" target="_blank" rel="noreferrer">Spear Thistle</a>
                    </li>
                    : <></>
                }
            </ul>
        </>);
};

export default AppleWeedsList;